import React, { useEffect, useState, useRef } from "react";
import { useSelector } from 'react-redux';
import { Chart } from "react-google-charts";
import TapSelect from "../../../components/ui/TapSelect";
import HttpAPICall from '../../../services/HttpAPICall';
import tapIcon from "../../../services/TapIcon";
import moment from "moment";
import UpdateMyDashboardForm from "../../settings/configurationGeneral/myDashboard/UpdateMyDashboardForm";
import Loader from "../../../components/ui/Loader/Loader";
import { INVENTORY_API_BASE_URL_2 } from '../../../services/TapApiUrls';
import DateService from "../../../services/DateService";
import TapHelper from "../../../services/TapHelper";

const ItemDemandWidget = (props) => {

    const widgetUrl = INVENTORY_API_BASE_URL_2 + "/demand_widget_data"
    const updateMyDashboardRef = useRef();
    const access_token = useSelector(state => state.auth.access_token);
    const widget_keys = useSelector(state => state.app.user_info?.widget_keys || []);
    const allWarehouses = useSelector(state => state.app.warehouses ? state.app.warehouses : []);

    const [widgetData, setWidgetData] = useState(null)

    const [formData, setFormData] = useState({
        warehouses: [],
        userFilters: [
            { value: 'tagged_me', label: 'My Tagged Demand' },
            { value: 'created_by_me', label: 'Demand Created By Me' },
        ],
        filterData: {
            canChange: false,
            tagged_user_filter: "",
            search_warehouse_id: "",
        }
    });

    const [demandData, setDemandData] = useState({
        loading: false,
        data: [],
        remark_time: '',
    });
    const [reload, setReload] = useState(false);


    useEffect(() => {
        if (!formData.filterData.canChange) return;
        demandWidgetData();
    }, [formData.filterData]);

    useEffect(() => {
        setFormData(pre => ({
            ...pre,
            warehouses: allWarehouses.map(w => ({ value: w.id, label: `${w.name} (${w.code})` }))
        }))
        const widget =
            widget_keys?.length > 0
                ? widget_keys.find(w => w.key === "isc_item_demand_widget")
                : null;

        setWidgetData(widget);
    }, []);

    useEffect(() => {
        setDemandData(prev => ({ ...prev, loading: true }));
        if (localStorage.getItem('demandWidget')) {
            const leadData = JSON.parse(localStorage.getItem('demandWidget'));
            if (leadData) {
                let diff = DateService.differenceInSeconds(
                    moment(leadData.time, 'DD-MM-YYYY HH:mm A').format()
                );

                if (diff <= 86400) {
                    setDemandData(prev => ({
                        ...prev,
                        data: leadData.data,
                        loading: false,
                        remark_time: leadData.time,
                    }));
                    return;
                }
                localStorage.removeItem('demandWidget');
            }
        }

       // setTimeout(() => {
            demandWidgetData();
       // }, 1000 * (props.indexProps || 12));
    }, []);

    useEffect(() => {
        if (!reload) return;
        demandWidgetData();
    }, [reload]);

    const demandWidgetData = () => {
        setDemandData(prev => ({ ...prev, loading: true }));

        let params = {
            ...formData.filterData,
            reload: reload ? 'reload' : false
        };

        HttpAPICall.withAthorization('GET', widgetUrl, access_token, params, {}, (response) => {
            const res = response.data;
            setDemandData(prev => ({
                ...prev,
                data: res.data,
                remark_time: res.time
            }));
           // if (reload) {
                localStorage.setItem('demandWidget', JSON.stringify(res));
           // }
        }).then(() => {
            setDemandData(prev => ({ ...prev, loading: false }));
            setReload(false);
            setFormData(prev => ({
                ...prev,
                filterData: {
                    ...prev.filterData,
                    canChange: false
                }
            }))
        });
    };

    const pinMyDashboardHandler = (widgetData = null) => {
        updateMyDashboardRef.current.updateMyDashboardModalInit(widgetData, {
            key: "isc_item_demand_widget",
            name: "Item Demand Widget"
        });
    };

    const handleCountClick = (data) => {
        const statusId = data.id;
        const taggedUserFilter = formData.filterData.tagged_user_filter;
        const warehouseId = formData.filterData.search_warehouse_id;

        const params = new URLSearchParams();
        if (statusId) {
            params.append('status_id', statusId);
        }
        if (taggedUserFilter) {
            params.append('tagged_user_filter', taggedUserFilter);
        }
        if (warehouseId) {
            params.append('warehouse_id', warehouseId);
        }

        const url = `/item_demand_list?${params.toString()}`;
        window.open(url, '_blank');
    };

    const totalValue = demandData.data.reduce((acc, d) =>
        acc + (parseInt(d.total_demands) > 0 ? parseInt(d.total_demands) : 0), 0);

    return (
        <div className="card mt-3">
            <div className="card-body">
                <div className="row">
                    <div className="col-5">
                        <h6 className="fw-bold primary_color mb-0">Item Demand Widget</h6>
                    </div>
                    <div className="col-3">
                        <TapSelect
                            options={formData.userFilters}
                            changeEvent={(selectedOption) => {
                                setFormData(prev => ({
                                    ...prev,
                                    filterData: {
                                        ...formData.filterData,
                                        canChange: true,
                                        tagged_user_filter: selectedOption ? selectedOption.value : ""
                                    }
                                }));
                            }}
                            value={formData.userFilters.find(u => u.value === formData.filterData.tagged_user_filter)}
                            isSearchable={true}
                            isClearable={true}
                            containerHeight="33px"
                            fontSize="93%"
                            width="100%"
                            placeholder="All Demand"
                        />
                    </div>
                    <div className="col-3 p0">
                        <TapSelect
                            options={formData.warehouses}
                            changeEvent={(selectedOption) => {
                                setFormData(pre => ({
                                    ...pre,
                                    filterData: {
                                        ...formData.filterData,
                                        canChange: true,
                                        search_warehouse_id: selectedOption ? selectedOption.value : ""
                                    }
                                }))
                            }}
                            value={formData.warehouses.find(u => u.value == formData.filterData.search_warehouse_id)}
                            isSearchable={true}
                            isClearable={true}
                            containerHeight="33px"
                            fontSize="93%"
                            width="99%"
                            placeholder="All Warehouses"
                        />
                    </div>
                    <div className="col-1 px-0 mx-0 text-center">
                        <div className="dropdown">
                            <tapIcon.imageIcon
                                icon={tapIcon.ListActionIcon}
                                alt="action-icon"
                                className="img-fluid px-2 btn btn-light btn-block"
                                data-bs-toggle="dropdown"
                                href="#"
                                role="button"
                                aria-expanded="false"
                            />
                            <ul className="dropdown-menu dropdown-menu-end">
                                <li className="dropdown-item" style={{ cursor: "pointer" }} onClick={() => setReload(true)}>
                                    Refresh
                                </li>
                                <li className="dropdown-item" style={{ cursor: "pointer" }} onClick={() => pinMyDashboardHandler(widgetData)}>
                                    {!widgetData ? "Pinned to My Dashboard" : "Unpinned from My Dashboard"}
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="row mt-2">
                    <div className="col-6">
                        <div style={{ overflowY: "auto", maxHeight: "300px" }}>
                            <table className="table table-hover table-bordered  bg-white">
                                <thead className="table-secondary">
                                    <tr>
                                        <th style={{ width: "33%" }} className="text-start" >Status</th>
                                        <th style={{ width: "33%" }} className="text-center ">No. of Transactions</th>
                                        <th style={{ width: "33%" }} className="text-end "> Qty</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {demandData.loading
                                        ? <tr> <td className="text-center" colSpan="3"><Loader /></td></tr>
                                        :
                                        demandData.data.length > 0
                                            ?
                                            demandData.data.map((d, i) => (
                                                <tr key={i}>
                                                    <td>{d.name}</td>
                                                    <td className="text-center ">
                                                        {d.total_demands ?
                                                            <>
                                                                <span
                                                                    className=" text-primary"
                                                                    style={{ cursor: 'pointer' }}
                                                                    onClick={() => handleCountClick(d)}
                                                                >
                                                                    {d.total_demands}
                                                                </span>
                                                            </>
                                                            : "-"}
                                                    </td>
                                                    <td className="text-end">
                                                        {d.qty && TapHelper.numberFormatter(Number(d.qty), 2)}
                                                    </td>
                                                </tr>
                                            ))
                                            :
                                            <tr> <td className="text-center" colSpan="3">No Record Found</td></tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="col-6 p0 mt-3 mb-1">
                        {demandData.loading
                            ? <Loader />
                            :
                            (demandData.data && totalValue > 0 ? (
                                <Chart
                                    chartType="PieChart"
                                    data={[['Status Name', 'Demand Count']].concat(demandData.data.map((d) => { return [d.name, d.total_demands]; }))}
                                    options={{
                                        legend: { position: 'labeled', labeledValueText: 'both' },
                                        pieSliceText: 'none',
                                        chartArea: { width: '90%', height: '90%' },
                                    }}
                                    rootProps={{ 'data-testid': '1' }} />
                            ) : null)}

                    </div>
                </div>

                <div className="col-sm-12 text-muted fs11">
                    Report as of {demandData.remark_time}
                </div>
            </div>
            <UpdateMyDashboardForm ref={updateMyDashboardRef} />
        </div>
    );
};

export default ItemDemandWidget;